import React from "react";

/** Bar strip of a fault's active hours per day across the selected period. */
export function FaultDailyProfile({ days, label }) {
  const list = days || [];
  const peak = Math.max(...list, 0.0001);
  return (
    <div className="mt-6">
      <div className="k-label">Daily profile</div>
      <div className="mt-3 flex items-end gap-2 h-24">
        {list.map((h, i) => (
          <div key={`${label}-day-${i}`} className="flex-1 flex flex-col items-center justify-end h-full">
            <div
              className="w-full rounded-t bg-[#156F5B]"
              style={{ height: `${(h / peak) * 100}%`, minHeight: h > 0 ? 4 : 0, transition: "height .4s ease" }}
            />
            <div className="mt-1 text-[9px] text-[#9CA3AF]">{h > 0 ? `${h.toFixed(1)}h` : "—"}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
